// 结算单详情-答卷明细列表字段
export const settlementDetailOptions = {
  column: [
    {
      width: 170,
      label: '答卷ID',
      value: 'answerId'
    },
    {
      width: 90,
      label: '结算费用（元）',
      value: 'realAmount'
    },
    {
      width: 90,
      label: '答卷单价（元）',
      value: 'singleAmount'
    },
    {
      width: 90,
      label: '调整金额（元）',
      value: 'adjustAmount'
    },
    {
      'min-width': 170,
      label: '调价说明',
      value: 'adjustDescribe'
    },
    {
      width: 60,
      label: '调价人',
      value: 'adjusterName'
    },
    {
      'min-width': 160,
      label: '调价时间',
      value: 'adjustTime'
    }
  ]
}
